module.exports = __webpack_public_path__ + "img/card02.4cdd39f8.png";